import React, { useEffect, useState } from "react";
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { useParams, useLocation } from "react-router-dom";

const CustomerVerify = () => {
  const { token } = useParams(); // ✅ top-level
  const query = new URLSearchParams(useLocation().search);
  const email = query.get("email");

  const [message, setMessage] = useState("Verifying your email...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token || !email) {
      setMessage("Invalid verification link.");
      setLoading(false);
      return;
    }

    // Call the Laravel API
    fetch(`https://api.passionateworlduniversity.com/api/customer/verify/${token}?email=${email}`)
      .then(res => res.json())
      .then(data => {
        setMessage(data.message || "Verification failed. Please try again.");
        setLoading(false);

        // Optional: Redirect after success
        if (data.message === "Email verified successfully. You can now log in.") {
          setTimeout(() => {
            window.location.href = "/login"; // redirect to login
          }, 3000); // 3 seconds delay
        }
      })
      .catch(() => {
        setMessage("Server error. Please try again later.");
        setLoading(false);
      });
  }, [token, email]);

  return (
    <>
      <SEO title="Email Verification" />
      <main className="page-wrapper">
        <HeaderTopBar />
        <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

        <div className="rn-section-gap" style={{ minHeight: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div className="container text-center">
            {loading ? (
              <p className="text-lg font-medium">Verifying your email...</p>
            ) : (
              <p className="text-lg font-medium">{message}</p>
            )}
          </div>
        </div>

        <FooterOne />
        <Copyright />
      </main>
    </>
  );
};

export default CustomerVerify;
